const BackendErrors = {
  "400001": "BAD_REQUEST_EC",
  "401001": "UNAUTHORIZED_EC",
  "404001": "RESOURCE_NOT_FOUND_EC",
  "500001": "SERVICE_UNAVALAIBLE_EC",
  "500100": "NOT_EXISTS",
  "500101": "NOT_VALID",
  "500102": "MULTIPLE_INSURED",
  "500103": "CODE_ALREADY_USED",
};

export type AwsGateRequest<T> = {
  method?: "get" | "post" | "put" | "del" | "patch" | "head";
  path?: string;
  headers?: Record<string, string>;
} & T;

export type AwsGateResponse<D> = D;

export type AwsGateError = {
  errorCode: keyof typeof BackendErrors;
  errorDescription: string;
  errorSeverity: "ERROR" | "WARNING";
  response?: {
    status: number;
    data: {
      message: string;
      errors: string[];
    };
  };
};

export type AwsGateCallbacks<D> = {
  onSuccess?: (data: D) => void;
  onFailure?: (gateError?: AwsGateError) => void;
  onIdle?: () => void;
  onPending?: () => void;
};

export enum ServiceType {
  CAI = "cai-service",
  DOCUMENT = "document-service",
  COMMUNICATION = "communication-service",
}
